import Mainmenu from "./Mainmenu";
import bot from "../images/happy.png";
import you from "../images/boy.png";
import LoadingDots from "./LoadingDots";
import { useEffect, useState } from "react";
import Greetings from "./Greetings";
import ProcessedFood from "./ProcessedFood";
import Feeds from "./Feeds";

const LastMenu2 =({menu}) =>{

    const [showFrame1, setShowFrame1] = useState(false);
    const [showFrame2, setShowFrame2] = useState(false);
    const [showFrame3, setShowFrame3] = useState(false);
    const [time] = useState(new Date().toLocaleTimeString());
    const [loading, setLoading] = useState(false);

     useEffect(() => {
        if (showFrame1 || showFrame2 || showFrame3) {
          setTimeout(() => setLoading(false), 1000);
        }
      }, [showFrame1, showFrame2, showFrame3]);
    


    const handleShowFrame1 = () => {
        setShowFrame1(true);
        setShowFrame2(false);
        setShowFrame3(false);
    }

    const handleShowFrame2 = () => {
        setShowFrame1(false);
        setShowFrame2(true);
        setShowFrame3(false);
    }

    const handleShowFrame3 = () => {
        setShowFrame1(false);
        setShowFrame2(false);
        setShowFrame3(true);
    }

    return(
        <>
            <div className="frame1 animated-frame" style={{textAlign: 'center'}}>
            How can I help you now? <br></br>     
                <button className="Menubtns" onClick={handleShowFrame1}>Previous Menu</button>
                <button className="Menubtns" onClick={handleShowFrame2}>Main Menu</button>
                <div style={{textAlign: 'center'}}><button className="Menubtns" onClick={handleShowFrame3}>Exit</button></div>
            </div>
            

            {showFrame1 && (
                <>
                
                   <div className="chatbot">
                     <img src={bot} alt="bot" className="bot" />
                     <div className="chatbot-time">{time}</div>
                   </div>
                {menu ===1 && (
                    <>
                    <ProcessedFood />
                    </>
                    )}
                {menu ===2 && <Feeds />}
               
                </>
            )}

            {showFrame2 && (
               <>
               <div className="you-time">
                 <img src={you} alt="boy" className="boy" />
                 You {time}
               </div>
               <div className="you-message">
                 <div className="frame2 animated-frame">Main Menu</div>
               </div>
   
               {loading ? (
                 <div className="frame1 animated-frame">
                   <LoadingDots />
                 </div>
               ) : (
                 <>
                   <div className="chatbot">
                     <img src={bot} alt="bot" className="bot" />
                     <div className="chatbot-time">{time}</div>
                   </div>
                   <Mainmenu />
                 </>
               )}
             </>
            )}

            {showFrame3 && (
                 <>
                 <div className="you-time">
                   <img src={you} alt="boy" className="boy" />
                   You {time}
                 </div>
                 <div className="you-message">
                   <div className="frame2 animated-frame">Exit</div>
                 </div>
     
                 {loading ? (
                   <div className="frame1 animated-frame">
                     <LoadingDots />
                   </div>
                 ) : (
                   <>
                   <div className="chatbot animated-frame">
                       <img src={bot} alt="bot" className="bot" />
                       <div className="chatbot-time">{time}</div>
                     </div>
                     <div className="frame1 animated-frame">
                       Thank You!, and I am Glad to Assist You.
                     </div>
                     {/* <Greetings /> */}
                   </>
                 )}
               </>
            )}

        </>
    );

}
export default LastMenu2;